module.exports = __webpack_public_path__ + "img/pt.89c81176.png";